// Connecteur Claude (PLAN_CONNECTEUR_MCP.md, lot 1e) : règles partagées par la page de consentement et la section
// « Applications connectées ».

// Id de demande émis par le back (secrets.token_urlsafe(24) = 32 car.) ; le back refuse au-delà de 64.
export const CONSENT_REQ_RE = /^[A-Za-z0-9_-]{16,64}$/;

// 503 du connecteur absent (routes/oauth.py) — à distinguer du 503 passager de Mongo (server.py), qui se réessaie.
export const CONNECTOR_UNAVAILABLE = "Connecteur Claude indisponible";

export function isConnectorUnavailable(err) {
  return err?.response?.status === 503 && err.response.data?.detail === CONNECTOR_UNAVAILABLE;
}

/** Seul retour autorisé après une décision : le callback exact de claude.ai (origine + chemin). */
export function isClaudeCallback(url) {
  try {
    const u = new URL(url);
    return u.origin === "https://claude.ai" && u.pathname === "/api/mcp/auth_callback";
  } catch {
    return false;
  }
}

/** Chemin de la page de consentement pour une demande (retour après login). */
export function consentPath(req) {
  return `/oauth/consent?req=${req}`;
}

/** `req` lu dans la query, sinon dans history.state (l'URL a déjà été nettoyée) ; "" s'il manque. */
export function consentReqOf(location) {
  const fromState = location?.state?.req;
  return new URLSearchParams(location?.search || "").get("req") || (typeof fromState === "string" ? fromState : "");
}
